import { RootState } from 'src/store';

import { IFilter } from '../filters/types';

export const selectDictFilter = (state: RootState): Partial<IFilter[]> => state.dicts.filters;
